import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import { CSSProperties } from "react";
import { Close } from "@mui/icons-material";
import { Controller, UseFormReturn } from "react-hook-form";

export type DefaultFormRadioGroupInputOption = {
  id: number,
  label: string,
  style?: CSSProperties,
};

/**
 * DefaultRadioGroupInput
 */

type Props<T extends {}> = {
  name: keyof T;
  label?: string;
  required?: boolean;
  options: DefaultFormRadioGroupInputOption[];
  showCleanButton?: boolean;
  readOnly?: boolean;
  reactHookForm: UseFormReturn<T>,
  onChangeValue?: (value: number | null) => void;
};

export const DefaultFormRadioGroupInput = <T extends {},>({
  name,
  label,
  required,
  options,
  showCleanButton,
  readOnly,
  reactHookForm,
  onChangeValue,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText: string | null = null;

        if (name in formState.errors) {
          const error = formState.errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <FormControl size="small" className="flex flex-row" required={required}>
            {label &&
              <FormLabel id="descontoSindical" error={helperText !== undefined && helperText !== null} required={required}>
                {label}
              </FormLabel>
            }

            <div className="flex flex-row items-center">
              <RadioGroup
                value={field.value ?? null}
                onBlur={field.onBlur}
                aria-labelledby={`input-radio-group-${name as string}`}
                row={true}
                onChange={e => {
                  const value = e.target.value ? Number(e.target.value) : null;
                  field.onChange(value);
                  onChangeValue?.(value);
                }}>

                {options?.map(opt => (
                  <FormControlLabel
                    key={opt.id}
                    className="text-black dark:text-white"
                    value={opt.id}
                    disabled={readOnly}
                    control={<Radio size="small" />}
                    label={<span style={opt.style}>{opt.label}</span>}
                  />
                ))}

              </RadioGroup>
              {
                (showCleanButton && field.value !== null && field.value !== undefined) &&
                <div className="ml-2">
                  <span
                    className="flex flex-row items-center cursor-pointer text-xs text-[#009C4E] font-bold"
                    onClick={() => {
                      onChangeValue?.(null);
                      field.onChange(null)
                    }}>
                    <Close /> Limpar
                  </span>
                </div>
              }
            </div>

            <FormHelperText id={`input-radio-group-${name as string}`} error={helperText !== undefined && helperText !== null}>
              {helperText}
            </FormHelperText>
          </FormControl>
        );
      }}
    />
  );
}